import { NON_ERP_COUNTRY_LIST } from "../components/common/CountryCode";
export const NON_ERP_UNAUTHORIZED_MODULES = ["invoice", "myContract"];

export const isNonERPCountryAccount = (contractAccountCountry) =>
  contractAccountCountry ? NON_ERP_COUNTRY_LIST.some((country) => country.countryCode.toLowerCase() === contractAccountCountry.toLowerCase()) : false;
